import styled from "styled-components";
import DefaultContainer from "./DefaultContainer";

const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #ffffff;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const SubTitle = styled.p`
  font-size: 17px;
  color: #64748b;
  line-height: 1.7;

  @media (max-width: 768px) {
    font-size: 15px;
    br {
      display: none;
    }
  }
`;

const ContactCard = styled.div`
  background: #f8fafc;
  border-radius: 16px;
  padding: 40px;
  border: 1px solid #e2e8f0;
  text-align: center;
  width: 100%;
  max-width: 400px;

  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`;

const ContactIcon = styled.div`
  font-size: 32px;
  margin-bottom: 16px;
`;

const ContactTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 12px;
`;

const ContactLink = styled.a`
  color: #3b82f6;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: #2563eb;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const ContactSection = () => {
  return (
    <Container>
      <DefaultContainer>
        <Contents>
          <Header>
            <Title>Contact Us</Title>
            <SubTitle>
              궁금하신 사항이 있으시거나 함께 일하고 싶으시다면 언제든 연락주세요.
              <br />
              빠른 시일 내에 답변드리겠습니다.
            </SubTitle>
          </Header>

          <ContactCard>
            <ContactIcon>📧</ContactIcon>
            <ContactTitle>이메일</ContactTitle>
            <ContactLink href="mailto:contact@followingmoments.com">
              contact@followingmoments.com
            </ContactLink>
          </ContactCard>
        </Contents>
      </DefaultContainer>
    </Container>
  );
};

export default ContactSection;
